import { render, staticRenderFns } from "./Garcom.vue?vue&type=template&id=b5511920&scoped=true&"
import script from "./Garcom.vue?vue&type=script&lang=js&"
export * from "./Garcom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5511920",
  null
  
)

export default component.exports